import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
    return (
        <main className="container-page py-24 max-w-xl fade-up text-center" data-testid="payment-cancel">
            <XCircle className="w-14 h-14 text-[#819888] mx-auto mb-6" strokeWidth={1.5} />
            <h1 className="text-3xl font-semibold text-[#1C2321] mb-3" style={{ fontFamily: "Outfit" }}>No worries — nothing was charged.</h1>
            <p className="text-lg text-[#515B57] mb-8">
                You can pick a plan whenever you're ready. Your trial and progress are still safe.
            </p>
            <div className="flex justify-center gap-3">
                <Link to="/pricing" className="px-6 py-3 rounded-lg bg-[#2D5D4E] text-[#FAF9F6] font-medium hover:bg-[#1F4237]">Back to pricing</Link>
                <Link to="/app" className="px-6 py-3 rounded-lg border border-[#E5E7E2] bg-white text-[#1C2321] font-medium hover:bg-[#E8E2D2]">Keep browsing</Link>
            </div>
        </main>
    );
}
